import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import styled from 'styled-components';
import { useAiAssistant } from '../../AiAssistantContext';

const TabBar: React.FC = () => {
  const { state, dispatch } = useAiAssistant();

  const handleClose = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation();
    dispatch({ type: 'CLOSE_TAB', tabId });
  };

  return (
    <Container>
      <TabsScroll>
        {state.tabs.map((tab) => (
          <Tab
            key={tab.id}
            $active={tab.id === state.activeTabId}
            onClick={() => dispatch({ type: 'SET_ACTIVE_TAB', tabId: tab.id })}
          >
            {tab.sessionId !== undefined && state.unreadSessionIds.includes(tab.sessionId) && (
              <UnreadDot />
            )}
            <TabLabel $isFile={tab.type === 'file'}>
              {tab.type === 'file' && <FileIndicator>F</FileIndicator>}
              {tab.label}
            </TabLabel>
            <CloseBtn onClick={(e) => handleClose(e, tab.id)}>
              <FontAwesomeIcon icon={faTimes} size="xs" />
            </CloseBtn>
          </Tab>
        ))}
      </TabsScroll>
    </Container>
  );
};

export default TabBar;

const Container = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
  padding: 0 4px 0 24px;
  min-height: 36px;
`;

const TabsScroll = styled.div`
  display: flex;
  flex: 1;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 3px;
  }
`;

const Tab = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid ${(p) => (p.$active ? '#1976d2' : 'transparent')};
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  &:hover {
    background: ${(p) => (p.$active ? '#fff' : '#eee')};
  }
`;

const TabLabel = styled.span<{ $isFile: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileIndicator = styled.span`
  font-size: 9px;
  font-weight: 700;
  background: #e0e0e0;
  border-radius: 2px;
  padding: 0 3px;
  color: #666;
`;

const UnreadDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1976d2;
  flex-shrink: 0;
  margin-right: 4px;
`;

const CloseBtn = styled.span`
  margin-left: 6px;
  opacity: 0.4;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

